import {ITEM_PER_PAGE} from "../config/_pagination";

const ACCOUNTING = '/picking/accounting';
const ORDERS = '/picking/orders';
const PICKING = '/picking';
const PRINTERS = '/picking/printers';
const QUOTES = '/quotes';
const QUOTE_DETAILS = '/quote/'
const QUOTES_STATISTICS = '/picking/statistics/quotes'
const RETAILERS = '/picking/retailers';

export const OMSRoutes = {
    ACCOUNTING,
    ORDERS,
    ORDERS_LIST: `${ORDERS}/${encodeURIComponent(`order[createdAt]=asc&status=pending&itemsPerPage=${ITEM_PER_PAGE}&page=1`)}`,
    PICKING,
    PRINTERS,
    QUOTE: (id) => `${QUOTE_DETAILS}${id}`,
    QUOTE_DETAILS,
    QUOTES,
    QUOTES_STATISTICS,
    RETAILERS,
    RETAILERS_LIST: `${RETAILERS}/${encodeURIComponent(`order[name]=asc&pagination=true&itemsPerPage=99999&retailer_has_order=true`)}`,
    RETAILER_ORDERS: (id) => `${RETAILERS}/${id}/order/${encodeURIComponent(`retailer.id=${id}&itemsPerPage=${ITEM_PER_PAGE}&page=1&pagination=true&status[1]=pending&status[2]=reserved&order[status]=asc&order[createdAt]=asc`)}`,
}
